<template>
  <!-- <div id="app" :style="{ 'background-image': `url(${random()})` }">
    <router-view/>
  </div> -->
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
      color: '#f24',
      images: [
        'https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      ],
    }
  },
  methods: {
    random() {
      return this.images[Math.floor(Math.random() * this.images.length)];
    }
  },
}
</script>

<style>
@import url(https://fonts.googleapis.com/earlyaccess/notosanstc.css);
* {
  font-family: 'Noto Sans TC';
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-blend-mode: color;
}
.mu-table th {
  font-size: 16px !important;
  background-color: rgb(217, 234, 249) !important;
  color: black;
}
.el-dialog__header {
  text-align: left !important;
}
.el-dialog__body {
  text-align: left !important;
}
.mu-table td {
  font-size: 16px !important;
}
.el-radio.is-bordered {
  margin: 0 !important;
  margin-right: 15px !important;
  margin-bottom: 15px !important;
}
.mu-table tr.is-selected {
  background-color: #fff !important;
}
.el-radio.is-bordered+.el-radio.is-bordered {
  margin: 0 !important;
  margin-right: 15px !important;
}
.el-textarea__inner {
  border: 1px solid #777 !important;
}
.mu-input {
  margin-bottom: 12px !important;
}
.mu-input.disabled .mu-input-help {
  color: #f44336 !important;
}
.el-table .cell {
  margin-left: 5px;
  margin-right: 5px;
}
.el-table td, .el-table th {
  padding: 8px 0 !important;
}
.el-upload {
  text-align: left !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
